import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20minimalist%20composition%20with%20soft%20curving%20organic%20shapes%20in%20terracotta%20and%20cream%20tones%2C%20gentle%20gradients%2C%20elegant%20editorial%20style%2C%20clean%20sophisticated%20design%2C%20no%20text%20no%20people%2C%20abstract%20art%20texture%20background&width=1800&height=800&seq=hero-main-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <h1 className="text-3xl md:text-5xl font-bold text-background-50 mb-5 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          换妻一族
        </h1>
        <p className="text-lg md:text-xl text-background-100/90 mb-3 leading-relaxed max-w-2xl mx-auto">
          开放关系探索者的深度指南
        </p>
        <p className="text-sm md:text-base text-background-200/80 mb-8 max-w-xl mx-auto leading-relaxed">
          换妻一族是指夫妻双方经协商同意、相互交换伴侣进行性探索的成人群体。本平台深度解析心理动机、安全守则、法律边界与社群文化，帮助好奇者理性了解这一成人亚文化现象。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/xinli-dongji"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            开始探索
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 text-background-50 border border-background-50/30 rounded-md text-sm font-medium hover:bg-background-50/30 transition-colors whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}